import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, Container, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { GroupAdd, ListAltOutlined, Visibility } from "@material-ui/icons";
import DescriptionIcon from '@material-ui/icons/Description';

import Cognisphere from "../../assets/images/newfront.gif";
import Loader from "../../Components/Loader/Loader";
import Header from "../../Components/Header/Header";
import SnackbarCustom from "../../Components/Snackbar/Snackbar";
import { custHeaderAction, storeLandingMenuItemsAction } from "../../Redux/Actions/actions";
import { getAllRoles } from "../../Redux/APIs/api_Common";
import { MasterRouteLanding, logoutUser } from "../../Utilities/Utility";
// At the top of your file, import the images if they are in src/assets
import icon8D from "../../assets/images/8d_icon.png";
import iconDev from "../../assets/images/dev_icon.png";
import iconPdir from "../../assets/images/pdir_icon.png";
import iconAdmin from "../../assets/images/admin_icon.png";
import "./Home.scss";

const useStyles = makeStyles((theme) => ({
    // Keeping your existing styles for compatibility
    loginTabs: {
        flexGrow: 1,
        backgroundColor: `rgba(255, 255, 255, 0.85)`,
        boxShadow: `0 8px 32px #CCCCCC`,
        borderRadius: "10px",
    },
}));

export default function Home() {
    const dispatch = useDispatch();
    const classes = useStyles();

    const userDetails = useSelector((state) => state.storeUserDetailsReducer.userData);
    const landingMenuItems = useSelector(state => state.storeLandingMenuItemsReducer.menuItems) || [];
    const siteToken = useSelector((state) => state.saveBearerTokenReducer);
    const azureToken = useSelector((state) => state.saveTokenReducer);
    const UID = useSelector((state) => state.saveUserIdReducer);

    const [isLoader, setIsLoader] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackAlertType, setSnackAlertType] = useState("");

    // Mapping icons to images or MUI Components
    const icons = {
        "<ListAltOutlined />": <ListAltOutlined />,
        "<DescriptionIcon />": <DescriptionIcon />,
        "<GroupAdd />": <GroupAdd />,
        // Use the imported variables here
        "8D Tool": icon8D,
        "Development Tool": iconDev,
        "Administrator": iconAdmin,
        "Inprocess/PDIR": iconPdir // FIXED: Changed from <ListAltOutlined /> to your imported image
    };

    useEffect(() => {
        if (userDetails?.userId > 0 && siteToken.token !== "" && landingMenuItems?.length <= 0) {
            getLandingMenus();
        }
        dispatch(custHeaderAction(userDetails.roleId === 3 && userDetails.supplierLoginType === 2 ? "ISIR Tool" : "SQM Tool"));
    }, [userDetails, landingMenuItems]);

    const getLandingMenus = () => {
        getAllRoles(siteToken, azureToken.token, UID.id, userDetails.userEmail, userDetails.gid, userDetails.role, userDetails.roleId)
            .then((response) => {
                dispatch(storeLandingMenuItemsAction(response || []));
            })
            .catch((err) => console.log(err));
    };

    const handleClose = () => setOpenSnack(false);

    return (
        <div className="home-page-wrapper main-component1">
            <Header />
            <main className="main-content-area">
                
           
                {landingMenuItems.length > 0 ? (
                    <Container maxWidth="lg" className="content-container">
                        <Container maxWidth="lg" className="content-container">
                      
                            <Grid container spacing={4} alignItems="flex-start">
                                {/* Left Side: Enhanced Greeting */}
                                <Grid item xs={12} lg={4}>
                                    <div className="attractive-welcome">
                                        <h1 className="main-greeting" style={{color:"white"}}>
                                            Hello, <span className="highlight-name" style={{color:"white"}}>{userDetails.userFirstName}</span>
                                        </h1>
                                        <div className="sub-welcome-box">
                                            <p className="sub-text" style={{color:"white"}}>Welcome to <strong>SQM Tool</strong></p>
                                        </div>
                                    </div>
                                </Grid>

                                {/* Right Side: 2x2 Grid Menu */}
                                <Grid item xs={12} lg={8}>
                                    <Grid container spacing={3}>
                                        {landingMenuItems.map((item, index) => (
                                            <Grid item xs={12} sm={6} key={index}> {/* Changed to sm={6} for 2 per row */}
                                                <Link to={item.menuLink} className="animated-menu-link">
                                                    <div className="tool-banner">
                                                        <div className="icon-box">
                                                            {typeof icons[item.menuName] === 'string' ? (
                                                                <img src={icons[item.menuName]} alt={item.menuName} />
                                                            ) : (
                                                                <div className="mui-icon-fallback">{icons[item.menuIcon]}</div>
                                                            )}
                                                        </div>
                                                        <div className="green-bar">
                                                            <span className="menu-label">{item.menuName}</span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>

                        {/* Decorative Bottom Image */}
                        {/* <div className="bottom-decoration-wrapper">
                            <img src={Cognisphere} alt="Process Flow" className="process-flow-img" />
                        </div> */}
                    </Container>
                ) : (
                    <Loader />
                )}

                {/*<img src={Cognisphere} alt="Background" className="bg-decoration-img" />*/}
            </main>

            <SnackbarCustom
                open={openSnack}
                message={snackMessage}
                alertType={snackAlertType}
                handleClose={handleClose}
            />
        </div>
    );
}